import { InjectionToken } from '@angular/core';

export const DATE_FORMAT = new InjectionToken<string>('dateFormat');


import { Inject, Injectable } from '@angular/core';
import { MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';

@Injectable({
  providedIn: 'root'
})
export class CustomDateAdapter extends NativeDateAdapter {
  constructor(@Inject(MAT_DATE_LOCALE) matDateLocale: string, @Inject(DATE_FORMAT) private dateFormat: string ) {
    super(matDateLocale);
  }

  // Override the format method to format the date dynamically
  override format(date: Date, displayFormat: Object): string {
    if (!date) return '';

    const day = this.padTo2Digits(date.getDate());
    const month = this.padTo2Digits(date.getMonth() + 1);
    const year = date.getFullYear();

    switch (this.dateFormat) {
      case 'dd/MM/yyyy':
        return `${day}/${month}/${year}`;
      case 'MM/dd/yyyy':
        return `${month}/${day}/${year}`;
      case 'yyyy/MM/dd':
        return `${year}/${month}/${day}`;
      case 'MMMM d, y':
        return `${this.getMonthName(date.getMonth())} ${day}, ${year}`;
      case 'MMM d, y':
        return `${this.getMonthAbbreviation(date.getMonth())} ${day}, ${year}`;
      default:
        return `${month}/${day}/${year}`; // Default to MM/dd/yyyy
    }
  }

  private padTo2Digits(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  private getMonthName(monthIndex: number): string {
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
      'September', 'October', 'November', 'December'
    ];
    return monthNames[monthIndex];
  }

  private getMonthAbbreviation(monthIndex: number): string {
    const monthAbbreviations = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug',
      'Sep', 'Oct', 'Nov', 'Dec'
    ];
    return monthAbbreviations[monthIndex];
  }
}